import { Percent } from 'eth-mainnet-few-sdk-core-2'

export default function formatPriceImpact(priceImpact: Percent) {
  return `${priceImpact.multiply(-1).toFixed(2)}%`
}
